// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__YxF1O","expandIcon":"AccordionButton_expandIcon__34DV1","expanded":"AccordionButton_expanded__19MWD"};